import type { DeliverySlot } from '@@partner:types:app'
import type { GQL_ID } from '@@partner:types:graphql'

import { gql, useQuery } from '@apollo/client'

export interface SingleSlotQuery {
  singleSlot: DeliverySlot
}

export interface SingleSlotVariables {
  slotId: GQL_ID
}

export const GQL_QUERY_SINGLE_SLOT = gql`
  query ($slotId: ID!) {
    singleSlot(id: $slotId) {
      id
      slotTime
      period {
        from
        to
      }
      shop_id
      zone_id

      shop {
        id
        name
        address
        tzOffset
      }
      deliveryZone {
        id
        name
        tzOffset
      }
      availableUntil
      position_capacity
      positions_count
      orders_capacity
      orders_count
      timeout
    }
  }
`

export const useFetchSingleSlot = (variables?: SingleSlotVariables) => {
  const { data, loading, error ,refetch } = useQuery<SingleSlotQuery, SingleSlotVariables>(GQL_QUERY_SINGLE_SLOT, {
    variables,
    fetchPolicy: 'network-only'
  })

  const slot = data?.singleSlot

  return {
    slot,
    data,
    loading,
    error,
    refetch
  }
}
